import React from 'react';

const LinkedIn = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 12.627 12.627"
			className={className}
		>
			<path
				fill="currentColor"
				d="M11.725 0H.9a.906.906 0 0 0-.9.91v10.807a.906.906 0 0 0 .9.91h10.825a.908.908 0 0 0 .9-.91V.91a.908.908 0 0 0-.9-.91ZM3.816 10.824H1.945V4.8h1.874v6.026ZM2.88 3.975A1.085 1.085 0 1 1 3.965 2.89a1.086 1.086 0 0 1-1.084 1.084Zm7.951 6.849H8.96V7.892c0-.7-.014-1.6-.972-1.6-.975 0-1.125.761-1.125 1.547v2.982H4.992V4.8h1.8v.823h.025a1.971 1.971 0 0 1 1.773-.972c1.894 0 2.246 1.249 2.246 2.872Z"
			/>
		</svg>
	);
};

export default LinkedIn;
